import React, {useEffect, useState} from "react";
import styled from "styled-components/macro";
import { useAuth } from "../../../../context/auth"
import {
    getCredibilityData,
} from "../../../../services/partner.service";
import LoaderWithBackDrop from "../../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";

import {
    Paper,
    Box,
    Grid as MuiGrid,
    Card as MuiCard,
    CardContent as MuiCardContent,
    Typography as MuiTypography,
    makeStyles, Button as MuiButton,
} from "@material-ui/core";

import { spacing } from "@material-ui/system";
import {Badge} from "./Badge.comp";
import LineChart from "./LineChart";
import HorizontalBarChart from "./HorizontalBarChart";

const useStyles = makeStyles(theme => ({
    stretch: { height: "100%" },
    item: { display: "flex", flexDirection: "column" } // KEY CHANGES
}));

const Grid = styled(MuiGrid)(spacing);

const Card = styled(MuiCard)(spacing);

const Button = styled(MuiButton)(spacing);

const Typography = styled(MuiTypography)(spacing);

const CardContent = styled(MuiCardContent)`
  position: relative;

  &:last-child {
    padding-bottom: ${(props) => props.theme.spacing(4)}px;
  }
`;

const ColouredTypography = styled(Typography)`
  color: ${(props) => props.color ? props.color : props.theme.sidebar.background};
  font-size: ${(props) => props.size ? props.size : "default"};
  text-align: ${(props) => props.textAlign ? props.textAlign : "left"};
`

const Spacer = styled.div(spacing);

const DefaultColouredTypography = styled(Typography)`
  color: ${(props) => props.color ? props.color : props.theme.sidebar.background};
  font-size: ${(props) => props.size ? props.size : "default"};
  font-family: "Lemon/Milk";
`



const Bold = (props) => <Box component={'span'} fontWeight="fontWeightBold" {...props}></Box>
const Italicize = (props) => <Box component={'span'} fontStyle="italic" {...props}></Box>
const Font = (props) => <Box component={'span'} fontFamily={props.font} {...props}></Box>

function CredibilityTab() {

    const {authUser} = useAuth();

    const [loading, setLoading] = useState(false);
    const [pageData, setPageData] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect( () => {
        loadPageData().then(d => console.log('Credibility Data Fetched!', d));
    }, []);

    const loadPageData = async () => {
        setLoading(true);
        try {
            const result = await getCredibilityData(authUser.org_code);
            if (result.data) {
                console.log('Result Data of Credibility --> ', result.data);
                setPageData(result.data);
            }
            else {
                setErrorMessage("No data found");
            }

        } catch (e) {
            console.log("Some error occurred while fetching credibility data")
        }
        setTimeout(() => {setLoading(false)}, 200);
    }

    const badge_data = [
        {
            title: "Evidence-Based Approach Score",
            value: pageData ? pageData.score : "0",
        },
    ]

    const mainChart = {
        header: "",
        labels: pageData ? pageData.labels : ["DQ 1", "DQ 2", "DQ 3", "DQ 4", "DQ 5", "DQ 6", "DQ 7", "DQ 8", "DQ 20", "DQ 21", "DQ 23", "DQ 24"],
        data: pageData ? pageData.data : [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    }

    function headers_callback(value, index) {
        if(index == 0)
            return "Low";
        else if(index == 2)
            return "Meet the expectations".split(' ');
        else if(index == 4)
            return "Above the expectations".split(' ');
        else
            return undefined;
    }

    return (
        pageData ?
        <Paper>
            <Card>
                <CardContent>
                    <Box sx={{ flexGrow: 1 }} align={"right"}>
                        <Grid container align={"center"} alignItems={"center"}>
                            {badge_data.map((badge) => (
                                    <Grid item xs={12} sm={5} md={4} lg={3}>
                                        <Badge
                                            title={badge.title}
                                            value={badge.value}
                                        />
                                    </Grid>
                                )
                            )}
                            <Grid item xs sm md lg>
                                <ColouredTypography mt={5} mb={5} variant={"body1"} align={"center"} color={"dimgrey"} size={"16px"} textAlign={"justify"}>
                                    Has the Program been developed, maintained, and/or evolved in an evidence based approach?
                                </ColouredTypography>
                            </Grid>
                        </Grid>
                        <Spacer mb={5}/>
                        <ColouredTypography variant={"h4"} textAlign={"center"}>
                            Credibility
                        </ColouredTypography>
                        <Spacer mb={10}/>
                        <Grid container >
                            {/*<Grid item xs={2} sm={3} md={4} lg={3}>*/}

                            {/*</Grid>*/}
                            <Grid item xs={12}>
                                <HorizontalBarChart
                                    labels={mainChart.labels}
                                    values={mainChart.data}
                                    color={true}
                                    threshold={2.5}
                                    datalabels={false}
                                    percentage={false}
                                    xtickslabels={true}
                                    suggestedMax={5}
                                    barsGap={80}
                                    headers_callback={headers_callback}
                                />
                            </Grid>
                        </Grid>
                        <Button mt={5} variant="contained">
                            Download Data
                        </Button>
                    </Box>
                </CardContent>
            </Card>
            <LoaderWithBackDrop loading={loading} />
        </Paper>
        :
        <Paper container>
            <DefaultColouredTypography variant={"h3"} align={'center'} py={5}>{errorMessage}</DefaultColouredTypography>
            <LoaderWithBackDrop loading={loading}/>
        </Paper>
    );
}

export default CredibilityTab;